import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumber, getAmountLabelForNumber } from 'utils'

import Box from '@mui/material/Box'

export interface CurrencyValueProps {
  baseFontSize?: number
  currency?: string
  precision?: number
  value: number | null | undefined
}

export function CurrencyValue({ baseFontSize = 1, currency, precision = 2, value }: CurrencyValueProps) {
  const { t: translate } = useTranslation()
  const number = formatNumber(value, translate, value && value < 0 ? 0 : precision)
  const suffix = getAmountLabelForNumber(value, translate, currency)

  return (
    <>
      <Box display="inline" fontWeight="700" fontSize={`${baseFontSize}rem`} mr={`${baseFontSize * 0.3}rem`}>
        {number}
      </Box>
      <Box display="inline" fontSize={`${baseFontSize * 0.65}rem`}>
        {suffix}
      </Box>
    </>
  )
}

export default CurrencyValue
